import PropTypes from 'prop-types';
import { Link } from '@blaze-cms/nextjs-components';

const FooterMenu = ({ href, name }) => (
  <li className="menu__list-item">
    <Link href={href}>{name}</Link>
  </li>
);

FooterMenu.propTypes = {
  href: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired
};

export default FooterMenu;
